import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  price: number;
  className?: string;
}
export function PriceDisplay({
  price,
  className = ''
}: PriceDisplayProps) {
  const [currency, setCurrency] = useState('$');
  useEffect(() => {
    const lang = navigator.language;
    if (['es-AR', 'es-MX', 'es-CL', 'es-CO', 'es-PE'].includes(lang)) {
      setCurrency('$');
    } else if (lang === 'es-ES') {
      setCurrency('€');
    } else if (lang === 'en-GB') {
      setCurrency('£');
    } else {
      setCurrency('$');
    }
  }, []);
  return <span className={className} data-id="element-256">
      {currency}
      {price}
    </span>;
}